import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';
import functions from './functions.js';

class Main {
	constructor() {
		this.onDOMLoaded();
		this.onDocumentLoad();
		this.onResize();
		this.onScroll();
		window.jQuery = window.$ = $;
	}

	onDocumentLoad() {
		window.addEventListener("load", (event) => {

		});
	}

	onDOMLoaded() {
		document.addEventListener("DOMContentLoaded", (event) => {
			functions.cookies();
			functions.burger();
			functions.slider();
		});

	}

	onResize() {
		window.addEventListener('resize', (event) => {

		});
	}
	onScroll() {
		window.addEventListener('scroll', (event) => {

		});
	}

}

new Main();





// WEBPACK FOOTER //
// ./src/scripts/index.js